module.exports = __webpack_public_path__ + "static/media/16UNODC18.47ccb554.jpg";